<template>
  <div class="pay">
    <mt-header title="我的钱包">
      <mt-button icon="back" slot="left" @click.native="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div class="showMoney">
      <img src="../assets/img/pay/pay.png">
      <h1>{{balance}}</h1>
      <p>账户余额(元)</p>
    </div>
    <div class="btns">
      <router-link to="/pay/tradeRecords">交易记录</router-link>
      <router-link :to="{path: '/pay/withdraw', query: {money: balance}}">提现</router-link>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui'
export default {
  name: 'pay',
  data () {
    return {
      balance: '',
      accountId: ''
    }
  },
  mounted () {
    // 初始化加载区
    this.fundData()
  },
  methods: {
    fundData: function () {
      this.accountId = this.STATE.state.loginId
      let _this = this
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      this.axios.get('url/fund/balance?accountId=' + _this.accountId + '')
      .then(function (res) {
        Indicator.close()
        _this.balance = res.data.msg
      }).catch(function (response) {
        Indicator.close()
      })
    }
  }
}
</script>

<style scoped>
.showMoney{
  background-color:#26a2ff;
  text-align: center;
  padding-bottom: 38px;
}
.showMoney img{
  width: 100%;
  height: auto;
}
.showMoney h1{
  font-size: 38px;
  color: #fff;
  margin:30px 0  15px;
}
.showMoney {
  font-size: 14px;
  color: #fff;
}
.btns{
  padding:15% 18px 0;
  margin-bottom: 70px; 
}
.btns a{
  display: block;
  width: 100%;
  font-size: 15px;
  text-align: center;
  line-height: 35px;
  border: none;
  outline: none;
  -webkit-border-radiu:20px;
  -moz-border-radiu:20px;
  border-radius:20px;
  margin-bottom: 15px;
  text-decoration: none;
}
.btns a:nth-child(1){
  background-color: #dcecfe;
  color:#0171fc;
}
.btns a:nth-child(2){
  color:#fff;
  background-color: #108ee9;
}
</style>


// WEBPACK FOOTER //
// pay.vue?5a7b74e2